import { render, staticRenderFns } from "./dup.vue?vue&type=template&id=a2e2b49c&lang=pug&"
import script from "./dup.vue?vue&type=script&lang=js&"
export * from "./dup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports